<nav class="navbar navbar-expand navbar-light ps-1 pt-0 pb-0" #navHeader >
  <div class="container-fluid buttons-and-filters-container">
    <button *ngIf="(canScrollLeft | async)" class="scroll-button smaller-font" (click)="scrollLeft()">&lt;</button>
    <div class="navbar-nav d-flex flex-nowrap align-items-center mt-2 mb-2 scroll-container" #filtersContainer>
      <div 
        *ngFor="let filter of (columnFiltersObservable | async);  let i = index"
        class="nav-item"
        id="{{'column-filter-' + filter.id}}"
      >
        <asax-result-table-column-filter [columnFilter]="filter"
                                        [isFirst]="i === firstWithValueIndex"
                                        (outColumnFilter)="onColumnFilter($event)"
                                        (outRemoveColumnFilter)="onRemoveColumnFilter($event)">
        </asax-result-table-column-filter>
      </div>
      <div *ngIf="displayRemove | async" class="nav-item">
          <button 
            class="btn btn-sm btn-light ms-1 smaller-font"
            (click)="removeColumnFilters()"
            placement="bottom"
            ngbTooltip="Remove all tab filters"
            >
              <i class="fa fa-times"></i>
          </button>
      </div>
    </div>
    <button *ngIf="(canScrollRight | async)" class="scroll-button ms-1 smaller-font" (click)="scrollRight()">&gt;</button>
  </div>
  <div class="container-fluid table-actions-container pe-1">
    <asax-result-table-columns-picker-container [id]="id">
    </asax-result-table-columns-picker-container>
    <asax-result-table-export-container [selectedRowsIds]="selectedRowsIds"
                                        [isExportFileBeingGenerated]="isExportFileBeingGenerated"
                                        (outExportRows)="onExportRows($event)">
    </asax-result-table-export-container>
    <asax-result-table-samp-container [selectedRowsIds]="selectedRowsIds"
                                      [isSampFileBeingGenerated]="isSampFileBeingGenerated"
                                      (outSampExport)="onSampExport($event)">
    </asax-result-table-samp-container>
  </div>
</nav>
<div class="position-relative">
  <ngx-datatable class="asax-result-table material striped"
                 [style.height.px]="height - navHeader.offsetHeight"
                 [columnMode]="ColumnMode.standard"
                 [sortType]="SortType.single"
                 [selectionType]="SelectionType.checkbox"
                 [messages]="{emptyMessage: '', totalMessage: ''}"
                 [targetMarkerTemplate]="targetMarkerTemplate"
                 [reorderable]="true"
                 [swapColumns]="false"
                 [scrollbarH]="true"
                 [scrollbarV]="true"
                 [externalPaging]="true"
                 [externalSorting]="true"
                 [headerHeight]="headerHeight"
                 [rowHeight]="rowHeight"
                 [limit]="pageSizeLimit"
                 [footerHeight]="0"
                 [rows]="rows"
                 [count]="totalRows"
                 [rowIdentity]="rowIdentity"
                 [rowClass]="rowClass"
                 [trackByProp]="'id'"
                 [sorts]="[sortNgxDataTable]"
                 (page)="onPage($event)"
                 (sort)="onSort($event)"
                 (reorder)="onReorder($event)"
                 (activate)="onActivate($event)">
    <ngx-datatable-column [sortable]="false"
                          [width]="20"
                          [frozenLeft]="true"
                          [canAutoResize]="false"
                          [resizeable]="false"
                          [name]="'checkbox'">
      <ng-template ngx-datatable-header-template>
        <input id="{{'toggle-rows-' + id}}"
               class="form-check-input m-0"
               type="checkbox"
               style="width: 1.3em;height: 1.3em;"
               [checked]="areAllRowsSelected"
               [indeterminate]="!areAllRowsSelected && selectedRowsIds?.length"
               [disabled]="!allRows?.length"
               (change)="toggleAllSelectedRows($event?.target?.checked)"/>
      </ng-template>
      <ng-template ngx-datatable-cell-template let-row="row">
        <input id="{{'toggle-row-' + row.id}}"
               *ngIf="row.releaseDate && !row.releaseDate?.startsWith('3')"
               class="form-check-input"
               type="checkbox"
               style="width: 1.2em;height: 1.2em; margin-top: 5px !important;"
               [class.border-danger]="row.releaseDate && row.releaseDate > now"
               [class.bg-danger]="row.releaseDate && row.releaseDate > now && isRowSelected(row)"
               [disabled]="!allRows?.length"
               [checked]="isRowSelected(row)"
               (change)="toggleSelectedRow(row)"/>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [sortable]="false"
                          [width]="20"
                          [frozenLeft]="true"
                          [canAutoResize]="false"
                          [resizeable]="false"
                          [name]="'go-to-source'">
      <ng-template ngx-datatable-header-template>
        <span id="{{'center-sky-rows-' + id}}"
              placement="right"
              ngbTooltip="Center sky for rows"
              container="body"
              style="cursor: pointer;font-size: 15px"
              (click)="centerSkyInRaDecFovForTable()">
                <i class="fa-light fa-crosshairs"></i>
          </span>
      </ng-template>
      <ng-template ngx-datatable-cell-template let-row="row">
        <ng-template #tipContent>
          <ng-container *ngIf="!!row.code">
            Center sky for project {{row.code}}
          </ng-container>
          <ng-container *ngIf="!!row.bibCode">
            Center sky for publication {{row.bibCode}}
          </ng-container>
          <ng-container *ngIf="!!row.datasetId">
            Center sky for source {{row.sourceName}}
          </ng-container>
        </ng-template>
        <div class="d-flex align-items-center justify-content-between">
          <span id="{{'center-sky-row-' + row.id}}"
                placement="right"
                [ngbTooltip]="tipContent"
                container="body"
                style="cursor: pointer;font-size: 15px"
                (click)="centerSkyInRaDecFovForRow(row)">
              <i class="fa-light fa-crosshairs"></i>
          </span>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [sortable]="false"
                          [width]="20"
                          [frozenLeft]="true"
                          [canAutoResize]="false"
                          [resizeable]="false"
                          [name]="'extremes'">
      <ng-template ngx-datatable-header-template>
          <span id="{{'zoom-rows-' + id}}" placement="right"
                ngbTooltip="Zoom to entire frequency range of all rows"
                container="body"
                style="cursor: pointer;font-size: 15px"
                (click)="setFrequencyChartExtremesForTable()">
          <i class="fa-light fa-arrows-left-right"></i>
        </span>
      </ng-template>
      <ng-template ngx-datatable-cell-template let-row="row">
        <ng-template #tipContent>
          <ng-container *ngIf="!!row.code">
            Center spectral coverage viewer on frequency coverage of project {{row.code}}
          </ng-container>
          <ng-container *ngIf="!!row.bibCode">
            Center spectral coverage viewer on frequency coverage of publication {{row.bibCode}}
          </ng-container>
          <ng-container *ngIf="!!row.datasetId">
            Center spectral coverage viewer on frequency coverage of source {{row.sourceName}}
          </ng-container>
        </ng-template>
        <div class="d-flex align-items-center justify-content-between">
          <span id="{{'zoom-row-' + row.id}}"
                placement="right"
                [ngbTooltip]="tipContent"
                container="body"
                style="cursor: pointer;font-size: 15px"
                (click)="setFrequencyChartExtremesForRow(row)">
            <i class="fa-light fa-arrows-left-right"></i>
          </span>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [sortable]="false"
                          [width]="20"
                          [frozenLeft]="true"
                          [canAutoResize]="false"
                          [resizeable]="false"
                          [name]="'similarity'">
      <ng-template ngx-datatable-header-template>
      </ng-template>
      <ng-template ngx-datatable-cell-template let-row="row">
        <asax-result-table-cell-similarity-container [row]="row">
        </asax-result-table-cell-similarity-container>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [sortable]="false"
                          [width]="20"
                          [frozenLeft]="true"
                          [canAutoResize]="false"
                          [resizeable]="false"
                          [name]="'download-row'">
      <ng-template ngx-datatable-header-template>
      </ng-template>
      <ng-template ngx-datatable-cell-template let-row="row">
        <ng-template #tipContent>
          <ng-container *ngIf="!!row.code">
            Explore and download project {{row.code}}
          </ng-container>
          <ng-container *ngIf="!!row.bibCode">
            Explore and download publication {{row.bibCode}}
          </ng-container>
          <ng-container *ngIf="!!row.datasetId">
            Explore and download source {{row.sourceName}}
          </ng-container>
        </ng-template>
        <div 
          *ngIf="row.releaseDate && !row.releaseDate?.startsWith('3')"
          class="d-flex align-items-center justify-content-between">
            <span id="{{'download-row-' + row.id}}"
                  placement="right"
                  [ngbTooltip]="tipContent"
                  container="body"
                  style="cursor: pointer;font-size: 14px;"
                  (click)="downloadRow(row)">
                <i class="fa-light fa-download"></i>
            </span>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column *ngIf="id === 'observations'"
                          [sortable]="false"
                          [width]="30"
                          [frozenLeft]="true"
                          [canAutoResize]="false"
                          [resizeable]="false"
                          [name]="'previews'">
      <ng-template ngx-datatable-header-template>
      </ng-template>
      <ng-template ngx-datatable-cell-template let-row="row">
        <asax-result-table-cell-previews-container [row]="row"
                                                   *ngIf="row?.releaseDate?.toString() <= now && !row?.project?.code?.startsWith('2011')">
        </asax-result-table-cell-previews-container>
      </ng-template>
    </ngx-datatable-column>
    <ng-container *ngFor="let column of (columnsObservable | async)">
      <ngx-datatable-column [id]="column.id"
                            [name]="column.name"
                            [width]="column.width"
                            [prop]="column.prop"
                            [frozenLeft]="column.frozenLeft"
                            [canAutoResize]="false"
                            [resizeable]="false">
        <ng-template ngx-datatable-header-template let-sort="sortFn" let-sortDir="sortDir">
          <asax-result-table-search-table-column-container [column]="column"
                                                           [sortDir]="sortDir"
                                                           (outSort)="sort()">
          </asax-result-table-search-table-column-container>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-row="row" let-value="value">
          <asax-result-table-search-table-cell-container [row]="row"
                                                         [value]="value"
                                                         [column]="column">
          </asax-result-table-search-table-cell-container>
        </ng-template>
      </ngx-datatable-column>
    </ng-container>
  </ngx-datatable>
  <div *ngIf="isLoading" class="position-absolute" style="height: 2px;top: 54px;right: 0;left: 0;">
    <div class="loading-bar">
      <div class="indeterminate"></div>
    </div>
  </div>
</div>

<ng-template #targetMarkerTemplate let-class="class">
  <div [ngClass]="class">
    <div class="fa-light fa-objects-align-right" *ngIf="class?.includes('dragFromLeft')"></div>
    <div class="fa-light fa-objects-align-left" *ngIf="class?.includes('dragFromRight')"></div>
  </div>
</ng-template>
